//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "COMMENT",
  components: {},
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      moon: new Date()
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};